import InstrumentViewData, { defaultInstrumentData, IInstrumentViewData } from "../../models/instrument/InstrumentViewData";

export interface IStationViewData {
    id: string;
    name: string;
    description: string;
    instruments: IInstrumentViewData[];

  }
  
  export interface IStationViewLabel {
    descriptionLabel: string;
  }
  
  export default class StationViewData implements IStationViewData, IStationViewLabel {
    id: string;
    name: string;
    description: string;
    instruments: IInstrumentViewData[];
    descriptionLabel: string;
  
    constructor(id: string, name: string, description: string, instruments: IInstrumentViewData[]) {
      this.id = id;
      this.name = name;
      this.description = description;
      this.instruments = instruments;
      this.descriptionLabel = "Description";
    }
  }
  
  const defaultStationData = new StationViewData("", "", "", []);
  export {defaultStationData};
  